import React from 'react';

export const Footer = ({ companyInfo }) => (
  <footer className="bg-slate-900 text-white py-12">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid md:grid-cols-4 gap-8 mb-8">
        <div>
          <div className="flex items-center space-x-2 mb-4">
            <img src={companyInfo.logo} alt="Den Cyber Solutions" className="h-6 w-6" />
            <span className="font-bold">{companyInfo.name}</span>
          </div>
          <p className="text-slate-400 text-sm">{companyInfo.slogan}</p>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Services</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><a href="#services" className="hover:text-cyan-400 transition-colors">Risk Assessments</a></li>
            <li><a href="#services" className="hover:text-cyan-400 transition-colors">Compliance Auditing</a></li>
            <li><a href="#services" className="hover:text-cyan-400 transition-colors">Security Consulting</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Frameworks</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><a href="#frameworks" className="hover:text-cyan-400 transition-colors">NIST RMF</a></li>
            <li><a href="#frameworks" className="hover:text-cyan-400 transition-colors">ISO 27001</a></li>
            <li><a href="#frameworks" className="hover:text-cyan-400 transition-colors">CCM</a></li>
          </ul>
        </div>
        <div>
          <h4 className="font-semibold mb-4">Company</h4>
          <ul className="space-y-2 text-sm text-slate-400">
            <li><a href="#about" className="hover:text-cyan-400 transition-colors">About Us</a></li>
            <li><a href="#case-study" className="hover:text-cyan-400 transition-colors">Case Studies</a></li>
            <li><a href="#contact" className="hover:text-cyan-400 transition-colors">Contact</a></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-800 pt-8 text-center text-sm text-slate-400">
        <p>&copy; {new Date().getFullYear()} {companyInfo.name}. All rights reserved.</p>
      </div>
    </div>
  </footer>
);
